// @flow
import React, { Component } from 'react'
import { Redirect, withRouter } from 'react-router-dom'
import { message as antdMessage } from 'antd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import Path from 'routes/path'
import { setUIState, containerIds } from 'redux/modules/ui'
import {
  actions as ReservationDetailActions,
  type State as ReservationDetailState,
} from 'redux/modules/reservationDetail'
import { showErrorMessage } from 'helpers/error'

import MainTemplate from 'components/templates/MainTemplate'
import ReservationChangeGuestPage from 'components/pages/ReservationChangeGuestPage'
import ReservationChangeGuestForm from 'components/organisms/ReservationChangeGuestForm'
import { getReservationChangeGuestFormProps } from 'components/organisms/ReservationChangeGuestForm/presenter'
import ReservationSidebarContainer from 'containers/organisms/ReservationSidebar'

import graphql from './graphql'

export type PropTypes = {
  match: {
    params: {
      ownerName: string,
    },
  },
  location: {
    pathname: string,
  },
  history: {
    replace: Function,
    push: Function,
  },
  ui: {
    loading?: ?boolean,
  },
  actions: {
    setUIState: Function,
    fetchReservationDetail: Function,
  },
  reservationDetail: ReservationDetailState,
}

class ReservationChangeGuestPageContainer extends Component<PropTypes, *, *> {
  constructor(props: PropTypes) {
    super(props)
    this.onClickBackToMessage = this.onClickBackToMessage.bind(this)
  }

  componentDidMount() {
    const { actions, reservationDetail, match, config, data } = this.props
    const { detail, messages } = reservationDetail

    // 直リンの場合の初期データ取得
    if (!detail.id) {
      actions.fetchReservationDetail({
        userId: data.viewer.id,
        reservationId: match.params.reservationId,
      })
    }
    window.scrollTo(0, 0)
  }

  componentDidUpdate(prevProps: PropTypes) {
    const { actions, data, reservationDetail, history, match } = this.props
    const { reservationDetail: prevReservationDetail } = prevProps

    // エラー系の表示
    if (
      reservationDetail.failedApproveChange !== null &&
      prevReservationDetail.failedApproveChange === null
    ) {
      showErrorMessage(reservationDetail.failedApproveChange)
    }
  }

  onClickBackToMessage: Function
  onClickBackToMessage(e: Event) {
    const { history, location, match } = this.props
    e.preventDefault()
    history.push(location.pathname)
    history.replace(Path.reservationDetail(match.params.reservationId))
  }

  render() {
    const {
      location,
      history,
      match,
      reservationDetail,
      ui,
      actions,
      data,
    } = this.props
    const { detail } = reservationDetail

    // 未承認予約がなければ直リンクした場合はメッセージ画面に戻す
    if (detail.id && !detail.unapproved_reservation_from_user) {
      antdMessage.warning(
        i18n.t('page.dashboard.reservation.error.nothingGuestChange'),
      )
      return (
        <Redirect to={Path.reservationDetail(match.params.reservationId)} />
      )
    }

    return (
      <MainTemplate
        title={i18n.t('server.www.reservationChangeGuest.title', {
          id: detail.id || '',
        })}
        isFixedHeader
        hideMustHeader
        hasFooter={false}
        {...this.props}
      >
        <ReservationChangeGuestPage
          sidebarComponent={<ReservationSidebarContainer />}
          isShowContentsSp
          isLoading={ui.isLoading}
        >
          <ReservationChangeGuestForm
            {...getReservationChangeGuestFormProps(
              reservationDetail,
              this.onClickBackToMessage,
            )}
          />
        </ReservationChangeGuestPage>
      </MainTemplate>
    )
  }
}

function mapStateToProps(state) {
  return {
    ui: state.ui,
    reservationDetail: state.reservationDetail,
    config: state.config,
  }
}
function mapDispatchToProps(dispatch: Dispatch<*>) {
  const bindActions = {
    setUIState,
    ...ReservationDetailActions,
  }
  return { actions: bindActionCreators(bindActions, dispatch) }
}

const WrappedContainer = withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(graphql(ReservationChangeGuestPageContainer)),
)

export default WrappedContainer



// WEBPACK FOOTER //
// ./src/containers/pages/ReservationChangeGuestPage/index.jsx